import React, { lazy } from "react";
import { Route } from "react-router";

import { RouteGuardApplicationRights } from "components/routes/RouteGuardApplicationRights";
import { LazyRouteElement } from "components/routes/LazyRouteElement";
import Layout from "components/layout/Layout";
import { Module } from "./Module";

const IndexLazy = lazy(() => import("./pages/CompensationOverview").then(module => ({ default: module.default })));
const PilotageCompensationOverviewLazy = lazy(() =>
    import("./pages/PilotageCompensationOverview").then((module) => ({
        default: module.PilotageCompensationOverview,
    })),
);

export function Routes() {
    return (
        <>
            <Route
                key="compensation-index"
                path="/pilot/compensation/"
                element={
                    <Layout>
                        <RouteGuardApplicationRights requiredApplicationRights={Module.applicationRights}>
                            <LazyRouteElement fallback={null}>{<IndexLazy />}</LazyRouteElement>
                        </RouteGuardApplicationRights>
                    </Layout>
                }
            /> 
            <Route
                key="compensation-pilotage-compensation-overview"
                path="/pilot/compensation/pilotage/:id"
                element={
                    <Layout>
                        <RouteGuardApplicationRights requiredApplicationRights={Module.applicationRights}>
                            <LazyRouteElement fallback={null}>{<PilotageCompensationOverviewLazy />}</LazyRouteElement>
                        </RouteGuardApplicationRights>
                    </Layout>
                }
            /> 
        </> 
    )
}
